import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import { INewTeam, ITeam } from "@/features/teams/team.types";

export const teamService = {
  getTeams(): Promise<AxiosResponse> {
    return http.get<ITeam[]>("/teams");
  },

  createTeam(payload: INewTeam): Promise<AxiosResponse> {
    return http.post("/teams", payload);
  },

  updateTeam(teamId: string, payload: INewTeam): Promise<AxiosResponse> {
    return http.patch(`/teams/${teamId}`, payload);
  },

  seedDefaultTeam(): Promise<AxiosResponse> {
    return http.post("/teams/seed-default");
  },
};
